import { api_GET, api_POST, api_PUT, api_POST_Unauthorize } from "api/_axios.js";

const centrocustos_api =
{
    getItem: function (grupoeconomico) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`CentroCustos/${encodeURIComponent(grupoeconomico)}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getPlanoContasDatasys: function (grupoeconomico) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`CentroCustos/GetPlanoContasDatasys/${encodeURIComponent(grupoeconomico)}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },


    post: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`CentroCustos`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default centrocustos_api
